import React, { MutableRefObject, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Webcam from 'react-webcam';

import CameraComponent from './CameraComponent';
import {
  selectIsPlayPrompter,
  selectStudioMode,
} from '../../../store/modules/studio/selectors';
import { StudioMode } from '../../../configs/studio';
import { setSetupAndTogglePrompter } from '../../../store/modules/studio/actions';


type Props = {
  webcamRef: MutableRefObject<Webcam & HTMLVideoElement | null>;
};

const Camera = ({ webcamRef }: Props) => {
  const studioMode = useSelector(selectStudioMode);
  const isTeleprompterPlay = useSelector(selectIsPlayPrompter);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isTeleprompterPlay) {
      dispatch(setSetupAndTogglePrompter());
    }
    // eslint-disable-next-line
  }, []);

  if (studioMode === StudioMode.CAMERA) {
    return (
      <CameraComponent webcamRef={webcamRef} />
    );
  }

  return null;
};

export default Camera;
